import React, { useEffect, useCallback } from "react";

const ActivationModal = ({ isOpen, onClose, children }) => {
  const handleKey = useCallback(
    (e) => {
      if (!isOpen) return;
      if (e.key === "Escape") onClose?.();
    },
    [isOpen, onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, handleKey]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/30 dark:bg-black/60 flex items-center justify-center"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="
          w-[90%] max-w-md rounded-lg shadow-xl border p-6
          bg-white text-gray-800 border-gray-200
          dark:bg-gray-900 dark:text-gray-100 dark:border-gray-700
          dark:[&_*]:!text-gray-100
        "
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default ActivationModal;